import BaseAuth from './BaseAuth';
import Passkey from "./passkey"; // New import for Passkey class
class Onboarding extends BaseAuth {

    init() {
        const translatableStrings = {
            keyCopied: 'Key copied',
        };

        let endpoints = ['do_not_ask_again', 'skip_onboarding'];
        this.passkey = new Passkey(this.root, this.settings); // New instance of Passkey added
        this.passkey.init(); // Initializing Passkey
        let that = this;

        endpoints.forEach(endpoint => {
            let endpointsElement = this.getElement(endpoint);
            if (endpointsElement !== null) {
                endpointsElement.addEventListener('click', (event) => { // Use arrow function here
                    event.preventDefault();
                    // we call the performFetchOp method and then log the response
                    this.performFetchOp(`/${endpoint}`, this.settings)
                        .then(response => response.json())
                        // We log the data and redirect to the redirect_to URL
                        .then(data => window
                            .location
                            .href = data.redirect_to)
                        // We catch any errors and log them
                        .catch(this.logFetchError);
                });
            }
        });

        let endpointElem = this.getElement('rsssl_continue_onboarding');
        const handleClick = (event) => {
            event.preventDefault();
            let urlExtension = '';
            let selectedProvider = this.getCheckedInputValue('preferred_method');
            if (selectedProvider === 'email') {
                let data = {
                    provider: selectedProvider,
                    redirect_to: this.settings.redirect_to,
                    user_id: this.settings.user_id,
                    login_nonce: this.settings.login_nonce
                };
                urlExtension = '/save_default_method_email';
                this.performFetchOp(urlExtension, data)
                    .then(response => response.json())
                    .then(data => {
                        this.getElement('rsssl_step_one_onboarding').style.display = 'none';
                        const validation_check = document.getElementById("rsssl_step_four_onboarding");
                        validation_check.style.display = "block";
                        // Removing the 'click' event listener from the rsssl_continue_onboarding id button
                        endpointElem.addEventListener('click', (event) => handleValidation(event, data));
                        endpointElem.removeEventListener('click', handleClick);

                    })
                    .catch(that.logFetchError);
            } else if (selectedProvider === 'totp') {
                // Hiding step one and showing step two
                this.getElement('rsssl_step_one_onboarding').style.display = 'none';
                // We hide this element
                endpointElem.style.display = 'none';
                this.getElement('rsssl_step_two_onboarding').style.display = 'block';
            } else if (selectedProvider === 'passkey') { // New Passkey handling block
                this.getElement('rsssl_step_one_onboarding').style.display = 'none';
                endpointElem.style.display = 'none';
                this.getElement('rsssl_step_three_onboarding').style.display = 'block';
                // Trigger Passkey registration from Onboarding
                this.passkey.fireRegistration().then(r => {
                    if (r) {
                        this.getElement('rsssl_step_three_onboarding').style.display = 'none';
                        this.getElement('rsssl_step_four_onboarding').style.display = 'block';
                    }
                });
            }
        }

        const handleValidation = async (event, data) => {
            event.preventDefault();
            let selectedProvider = this.getCheckedInputValue('preferred_method');
            let urlExtension = '/' + data.validation_action;
            let sendData = {
                user_id: this.settings.user_id,
                login_nonce: this.settings.login_nonce,
                redirect_to: this.settings.redirect_to,
                token: document.getElementById('rsssl-authcode').value,
                provider: selectedProvider
            };
            let response;
            try {
                response = await this.performFetchOp(urlExtension, sendData);
            } catch (err) {
                console.log('Fetch Error: ', err);
            }
            if (response && !response.ok) {
                let error = await response.json();
                this.displayTwoFaOnboardingError(error.error);
            }
            if (response && response.ok) {
                let data = await response.json();
                window.location.href = data.redirect_to;
            }
        };

        if (endpointElem !== null) {
            endpointElem.addEventListener('click', handleClick);
        }

        let totpSubmit = this.getElement('two-factor-totp-submit');
        if (totpSubmit !== null) {
            totpSubmit.addEventListener('click', async (event) => {
                event.preventDefault();
                let authCode = document.getElementById('two-factor-totp-authcode').value;
                let key = this.settings.totp_data.key;
                let selectedProvider = this.getCheckedInputValue('preferred_method');
                let sendData = {
                    'two-factor-totp-authcode': authCode,
                    provider: selectedProvider,
                    key: key,
                    redirect_to: this.settings.redirect_to,
                    user_id: this.settings.user_id,
                    login_nonce: this.settings.login_nonce
                };
                try {
                    let response = await this.performFetchOp('/save_default_method_totp', sendData);
                    if (!response.ok) {
                        let error = await response.json();
                            this.displayTwoFaOnboardingError(error.error);
                    } else {
                        let data = await response.json();
                        window.location.href = data.redirect_to;
                    }
                } catch (error) {
                    this.logFetchError(error);
                }
            });
        }

        let resendButton = this.getElement('rsssl-two-factor-email-code-resend');
        if (resendButton !== null) {
            resendButton.addEventListener('click', (event) => {
                event.preventDefault();
                const data = {
                    user_id: this.settings.user_id,
                    login_nonce: this.settings.login_nonce,
                    provider: 'email'
                };
                this.performFetchOp('/resend_email_code', data)
                    .then(response => {
                        return response.json()
                            .then(responseData => {
                                if (!response.ok) {
                                    this.displayTwoFaOnboardingError(responseData.error || responseData.message);
                                } else {
                                    this.clearTwoFactorPrompt();
                                    this.displayTwoFaOnboardingSuccess(responseData.message);
                                }
                            })
                            .catch(jsonErr => {
                                console.error('Invalid JSON response:', jsonErr);
                            });
                    })
                    .catch(err => {
                        this.logFetchError(err);
                    });
            });
        }

        let downloadButton = this.getElement('download_codes');

        downloadButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.download_codes();
        });

        let passkeySubmit = this.getElement('rsssl-register-passkey'); // New Passkey submission handling
        if (passkeySubmit !== null) {
            passkeySubmit.addEventListener('click', (event) => {
                event.preventDefault();
            });
        }

        this.getElement('two-factor-qr-code').addEventListener('click', function (e) {
            e.preventDefault();
            that.copyTextAndShowMessage();
        });

        this.getElement('totp-key').addEventListener('click', function (e) {
            e.preventDefault();
            that.copyTextAndShowMessage();
        });
        if (document.readyState === 'complete') {
            this.qr_generator();

        } else {
            this.qr_generator();
        }
    }

    displayTwoFaOnboardingError(error) {
        let loginForm = document.getElementById('two_fa_onboarding_form');
        if (loginForm) {
            let errorDiv = document.getElementById('login-message');
            if(!errorDiv) {
                errorDiv = document.createElement('div');
                errorDiv.id = 'login-message';
                errorDiv.className = 'notice notice-error message';
                loginForm.insertAdjacentElement('beforebegin', errorDiv);
            }
            errorDiv.innerHTML = `<p>${error}</p>`;
            setTimeout(() => {
                // removing the error box from the loginForm
                errorDiv.remove();
            }, 5000);
        }
    }

    displayTwoFaOnboardingSuccess(message) {
        let loginForm = document.getElementById('two_fa_onboarding_form');
        if (loginForm) {
            let messageDiv = document.getElementById('login-message-success');
            if (!messageDiv) {
                messageDiv = document.createElement('div');
                messageDiv.id = 'login-message-success';
                messageDiv.className = 'notice notice-success message';
                loginForm.insertAdjacentElement('beforebegin', messageDiv);
            }
            messageDiv.innerHTML = `<p>${message}</p>`;
            setTimeout(() => {
                messageDiv.remove();
            }, 5000);
        }
    }

    clearTwoFactorPrompt() {
        // Select elements by class name without the dot prefix
        let elements = document.getElementsByClassName('two-factor-prompt');
        for (let i = 0; i < elements.length; i++) {
            // Clear the content of each element
            elements[i].innerHTML = '';
            // Optionally hide the element
            elements[i].style.display = 'none';
        }
    }
}
export default Onboarding;